
    <span
      class="badge badge-default"
      *ngFor="let tag of params.data.tags"
      [style.background-color]="tag.color"
      style="color: white"
      >{{ tag.name }}</span
    >
  